import _ from 'lodash'
import SubscriptionRecord from '../billing/SubscriptionRecord'

class SubscriptionController {

  constructor(
      $analytics,
      SubscriptionService,
      $uibModal) {
    this.$analytics = $analytics
    this.SubscriptionService = SubscriptionService
    this.$uibModal = $uibModal

    this.getSubscriptionInfo()
    this.subscriptionPatch = {}
  }

  getSubscriptionInfo() {
    this.subscriptionGetFailed = ''
    this.SubscriptionService.subscription(
      this._getSubscriptionInfoSuccess.bind(this),
      this._getSubscriptionInfoFail.bind(this))
  }

  _getSubscriptionInfoSuccess(s) {
    this.subscription = new SubscriptionRecord(s.subscription)
  }

  _getSubscriptionInfoFail() {
    this.subscriptionGetFailed = `We could not get your subscription details.
      Please try again later.`
  }

  updatePatch() {
    this.updateSuccess = ''
    this.updateFailure = ''
    this.SubscriptionService.updateSubscriptionPatch()
      .then((d) => {
        this._makeSubscriptionChangeTemplate(d)
        this._triggerModal()
      }, (e) => {
        this._handleSubscriptionDataGatherError()
      })
  }

  _makeSubscriptionChangeTemplate(data) {
    this.subscriptionPatch.planOptions = data.plans.plans
    this.subscriptionPatch.coverageOptions = data.addOns
    this.subscriptionPatch.plan = data.currentSub.subscription.plan

    // make a base coverage object with false for all
    this.subscriptionPatch.coverage = {}
    _.map(this.subscriptionPatch.coverageOptions[this.subscription.plan].addOns, (a) => {
      this.subscriptionPatch.coverage[a.addOn] = false
    })
    // fill it with true for current addOns
    _.map(this.subscription.subscriptionAddOns, (a) => {
      this.subscriptionPatch.coverage[a.addOnCode] = true
    })
  }

  _triggerModal() {
    var updateModalInstance = this.$uibModal.open({
      animation: true,
      templateUrl: 'update-subscription.partial.html',
      controller: 'UpdateSubscriptionModalController',
      size: 'lg',
      resolve: { subscriptionPatch: () => this.subscriptionPatch }
    })
    updateModalInstance.result.then((subscriptionPatch) => {
      this.updateSubscription(subscriptionPatch)
    })
  }

  _handleSubscriptionDataGatherError() {
    this.subscriptionUpdateFailed = `We will not be able to update your subscription
      at this time. Please try again later.`
  }

  updateSubscription(subscriptionPatch) {
    this.SubscriptionService.updateSubscription(
      {plan: subscriptionPatch.plan,
      addOns: _.keys( _.pick(subscriptionPatch.coverage, (val, key) => val === true))},
      this._updateSuccess.bind(this), this._updateFailure.bind(this))
  }

  _updateSuccess() {
    this.updateSuccess = 'Your subscription has been updated!'
    this.getSubscriptionInfo()
  }

  _updateFailure() {
    this.updateFailure = 'We could not update your subscription. Please try again later.'
  }

}

SubscriptionController.$inject = [
  '$analytics',
  'SubscriptionService',
  '$uibModal'
]

export default SubscriptionController
